import React from 'react';
import _ from 'lodash';

import {
  fields,
  Form,
  SectionHeaderBox,
  Table
} from 'iron-forge-react-modules';
import {
  Button,
  Grid,
  Paper as MuiPaper,
  styled
} from '@mui/material';
import {
  appFormUtil,
  FormattedCode
} from 'modules';

import { useForm } from 'react-hook-form';
import { DateTime } from 'luxon';
import * as dataService from './dataService';
import * as types from './types';



const Paper = styled(MuiPaper)(() => ({
}));

const FormGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3)
}));

const TableComponent = Table.genTableComponent<types.IColumnId>({});
const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();
const ControlledDateField = fields.DateField.genControllerComponent<types.IFormState>();



export const FC: React.FC = () => {
  const {
    queryTuple,
    pageInfo,
    fnQueryPage,
    fnQuery
  } = dataService.useQuery();

  const form = useForm<types.IFormState>({
    defaultValues: {
      omniFreeText: '',
      after: DateTime.now().minus({ days: 1 }).toJSDate(),
      before: DateTime.now().endOf('day').toJSDate()
    }
  });



  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      fnQuery({
        filter: appFormUtil.trimFormStateValues(formState)
      });
    },
    [fnQuery]
  );



  const rows = React.useMemo(
    () => _.map(queryTuple.data.tickets, (ticket): types.IRow => ({
      id: ticket.id,
      expandedContent: (
        <FormattedCode.FC content={ticket.context} />
      ),
      columnId2Value: {
        title: {
          type: 'string',
          label: ticket.title
        },
        createdAt: {
          type: 'string',
          label: ticket.createdAt.toFormat('yyyy-MM-dd @ HH:mm:ss')
        },
        description: {
          type: 'string',
          label: ticket.description
        },
        key: {
          type: 'string',
          label: ticket.key
        },
        labels: {
          type: 'string',
          label: ticket.labels
        }
      }
    })),
    [queryTuple.data.tickets]
  );

  return (
    <Paper>
      <SectionHeaderBox.FC>
        <Form.FC
          disableDefaultOverflow
          onSubmit={form.handleSubmit(processSubmit)}>
          <FormGrid container spacing={3}>
            <Grid
              item
              xs={2}>
              <ControlledTextField
                label="Search"
                fieldKey="omniFreeText"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={2}>
              <ControlledDateField
                label="Created after"
                fieldKey="after"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={2}>
              <ControlledDateField
                label="Created before"
                fieldKey="before"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={2}>
              <Button
                variant="contained"
                type="submit">Search</Button>
            </Grid>
          </FormGrid>
        </Form.FC>
      </SectionHeaderBox.FC>

      <TableComponent
        paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
        onChangeSortOptions={options => fnQuery({ sort: options })}
        rows={rows}
        initSortOptions={{
          columnId: 'createdAt',
          direction: 'descending'
        }}
        columns={[
          {
            id: 'key',
            label: "Key",
            sortType: 'string'
          },
          {
            id: 'createdAt',
            label: "Created At",
            sortType: 'number'
          },
          {
            id: 'title',
            label: "Title",
            sortType: 'string'
          },
          {
            id: 'labels',
            label: "Labels"
          },
          {
            id: 'description',
            label: "Description"
          }
        ]} />
    </Paper>
  );
};
